import { generatedAPI } from '@grafana/api-clients/rtkq/notifications.alerting/v1beta1';

export const timeIntervalsApi = generatedAPI;
